import _implicitStylesheets from "./overviewV2.css";
import _implicitScopedStylesheets from "./overviewV2.scoped.css?scoped=true";
import _listingCarouselV2 from "listing/carouselV2";
import _listingWatchDemo from "listing/watchDemo";
import _listingOverviewHighlights from "listing/overviewHighlights";
import _wdsGridItem from "wds/gridItem";
import _listingAchievements from "listing/achievements";
import _listingSocialImpact from "listing/socialImpact";
import _wdsTitledGroup from "wds/titledGroup";
import _axIcon from "ax/icon";
import _wdsLink from "wds/link";
import _wdsLabeledValue from "wds/labeledValue";
import _wdsGrid from "wds/grid";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<h3${"a0:id"} type-style="display-6" class="features-label${0}"${2}>${"t1"}</h3>`;
const $fragment2 = parseFragment`<p type-style="body-2" class="section-text listing-description${0}" data-testid="short-description-text"${2}>${"t1"}</p>`;
const $fragment3 = parseFragment`<p type-style="body-2" class="section-text description-text${0}" data-testid="description-text"${2}>${"t1"}</p>`;
const $fragment4 = parseFragment`<h3${"a0:id"} type-style="display-6" class="categories-label${0}"${2}>${"t1"}</h3>`;
const $fragment5 = parseFragment`<h3${"a0:id"} type-style="display-6" class="compatibility-label${0}"${2}>${"t1"}</h3>`;
const $fragment6 = parseFragment`<span${3}>${"t1"}</span>`;
const stc0 = {
  classMap: {
    "wrapper": true
  },
  key: 0
};
const stc1 = {
  props: {
    "gridFlow": "wrap",
    "gridRowGap": "xxx-large"
  },
  key: 1
};
const stc2 = {
  props: {
    "gridItemSize": "1:1"
  },
  key: 2
};
const stc3 = {
  "features-section": true
};
const stc4 = {
  classMap: {
    "features-content": true
  },
  key: 6
};
const stc5 = {
  classMap: {
    "carousel-wrapper": true
  },
  attrs: {
    "data-testid": "carousel-wrapper"
  },
  key: 7
};
const stc6 = {
  "carousel": true
};
const stc7 = {
  props: {
    "gridItemSize": "1:1"
  },
  key: 15
};
const stc8 = {
  "achievements-section": true
};
const stc9 = {
  props: {
    "gridItemSize": "1:1"
  },
  key: 18
};
const stc10 = {
  "social-impact-section": true
};
const stc11 = {
  props: {
    "gridItemSize": "1:1"
  },
  key: 21
};
const stc12 = {
  "categories-section": true
};
const stc13 = {
  classMap: {
    "pill-groups": true
  },
  attrs: {
    "data-testid": "overview-pill-groups"
  },
  key: 25
};
const stc14 = {
  "pill-group": true
};
const stc15 = {
  "data-testid": "industry-competencies-group"
};
const stc16 = {
  "data-testid": "product-competencies-group"
};
const stc17 = {
  "data-testid": "geographic-focus-group"
};
const stc18 = {
  "data-testid": "languages-group"
};
const stc19 = {
  "data-testid": "business-needs-group"
};
const stc20 = {
  "data-testid": "supported-industries-group"
};
const stc21 = {
  "data-testid": "target-personas-group"
};
const stc22 = {
  "data-testid": "supported-features-group"
};
const stc23 = {
  props: {
    "gridItemSize": "1:1"
  },
  key: 34
};
const stc24 = {
  "compatibility-section": true
};
const stc25 = {
  classMap: {
    "pill-groups": true
  },
  key: 38
};
const stc26 = {
  "data-testid": "compatibility-required-products"
};
const stc27 = {
  "data-testid": "compatibility-compatible-with"
};
const stc28 = {
  "data-testid": "compatibility-salesforce-editions"
};
const stc29 = {
  "data-testid": "compatibility-supported-languages"
};
const stc30 = {
  "data-testid": "compatibility-accessibility"
};
const stc31 = {
  "compatibility-external-link": true
};
const stc32 = {
  classMap: {
    "new_window__icon": true
  },
  props: {
    "size": "small",
    "icon": "new_window",
    "ariaHidden": "true"
  },
  key: 46
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {gid: api_scoped_id, d: api_dynamic_text, sp: api_static_part, st: api_static_fragment, c: api_custom_element, h: api_element, fid: api_scoped_frag_id} = $api;
  return [api_element("div", stc0, [api_custom_element("wds-grid", _wdsGrid, stc1, [$cmp.hasFeaturesSection ? api_custom_element("wds-grid-item", _wdsGridItem, stc2, [api_element("section", {
    classMap: stc3,
    attrs: {
      "data-testid": "features-section",
      "aria-labelledby": api_scoped_id("features-heading")
    },
    key: 3
  }, [api_static_fragment($fragment1, 5, [api_static_part(0, {
    attrs: {
      "id": api_scoped_id("features-heading")
    }
  }, null), api_static_part(1, null, api_dynamic_text($cmp.i18n.heading.overview))]), api_element("div", stc4, [$cmp.hasCarouselWrapper ? api_element("div", stc5, [$cmp.hasShortDescription ? api_static_fragment($fragment2, 9, [api_static_part(1, null, api_dynamic_text($cmp.formattedShortDescription))]) : null, $cmp.hasCarouselItems ? api_custom_element("listing-carousel-v2", _listingCarouselV2, {
    classMap: stc6,
    props: {
      "mediaItems": $cmp.carouselItems,
      "isMobile": $cmp.isMobilePhone
    },
    key: 10
  }) : null]) : null, $cmp.hasWatchDemo ? api_custom_element("listing-watch-demo", _listingWatchDemo, {
    props: {
      "heading": $cmp.watchDemoHeading,
      "href": $cmp.watchDemoUrl,
      "previewUrl": $cmp.watchDemoPreviewUrl,
      "label": $cmp.i18n.listingDetails.carousel.watchDemo,
      "hasDemoLeadsEnabled": $cmp.hasDemoLeadsEnabled
    },
    key: 11
  }) : null, $cmp.hasHighlights ? api_custom_element("listing-overview-highlights", _listingOverviewHighlights, {
    props: {
      "highlights": $cmp.highlights
    },
    key: 12
  }) : null, $cmp.hasDescription ? api_static_fragment($fragment3, 14, [api_static_part(1, null, api_dynamic_text($cmp.formattedDescription))]) : null])])]) : null, $cmp.hasProviderAchievements ? api_custom_element("wds-grid-item", _wdsGridItem, stc7, [api_element("section", {
    classMap: stc8,
    attrs: {
      "data-testid": "achievements-section",
      "aria-label": $cmp.achievementsHeading
    },
    key: 16
  }, [api_custom_element("listing-achievements", _listingAchievements, {
    props: {
      "listing": $cmp.listing
    },
    key: 17
  })])]) : null, $cmp.hasSocialImpact ? api_custom_element("wds-grid-item", _wdsGridItem, stc9, [api_element("section", {
    classMap: stc10,
    attrs: {
      "data-testid": "social-impact-section",
      "aria-label": $cmp.socialImpactHeading
    },
    key: 19
  }, [api_custom_element("listing-social-impact", _listingSocialImpact, {
    props: {
      "listing": $cmp.listing,
      "trackLearnMoreAsTile": true
    },
    key: 20
  })])]) : null, $cmp.hasCategories ? api_custom_element("wds-grid-item", _wdsGridItem, stc11, [api_element("section", {
    classMap: stc12,
    attrs: {
      "data-testid": "categories-section",
      "aria-labelledby": api_scoped_id("categories-heading")
    },
    key: 22
  }, [api_static_fragment($fragment4, 24, [api_static_part(0, {
    attrs: {
      "id": api_scoped_id("categories-heading")
    }
  }, null), api_static_part(1, null, api_dynamic_text($cmp.i18n.heading.categories))]), api_element("div", stc13, [$cmp.isConsultantListing ? $cmp.categoryGroups.industryCompetencies.length ? api_custom_element("wds-titled-group", _wdsTitledGroup, {
    classMap: stc14,
    attrs: stc15,
    props: {
      "titleTypeStyle": "body-2",
      "titleRole": "heading",
      "titleAriaLevel": "4",
      "title": $cmp.i18n.listingDetails.industryCompetenciesGroup,
      "badges": $cmp.categoryGroups.industryCompetencies
    },
    key: 26
  }) : null : null, $cmp.isConsultantListing ? $cmp.categoryGroups.productCompetencies.length ? api_custom_element("wds-titled-group", _wdsTitledGroup, {
    classMap: stc14,
    attrs: stc16,
    props: {
      "titleTypeStyle": "body-2",
      "titleRole": "heading",
      "titleAriaLevel": "4",
      "title": $cmp.i18n.listingDetails.productCompetenciesGroup,
      "badges": $cmp.categoryGroups.productCompetencies
    },
    key: 27
  }) : null : null, $cmp.isConsultantListing ? $cmp.categoryGroups.geographicFocus.length ? api_custom_element("wds-titled-group", _wdsTitledGroup, {
    classMap: stc14,
    attrs: stc17,
    props: {
      "titleTypeStyle": "body-2",
      "titleRole": "heading",
      "titleAriaLevel": "4",
      "title": $cmp.i18n.heading.geographicFocus,
      "badges": $cmp.categoryGroups.geographicFocus,
      "tooltip": $cmp.geographicFocusTooltip,
      "tooltipOrientation": $cmp.infoIconTooltipOrientation,
      "flipIfOverflowsViewport": true
    },
    key: 28
  }) : null : null, $cmp.isConsultantListing ? $cmp.categoryGroups.languages.length ? api_custom_element("wds-titled-group", _wdsTitledGroup, {
    classMap: stc14,
    attrs: stc18,
    props: {
      "titleTypeStyle": "body-2",
      "titleRole": "heading",
      "titleAriaLevel": "4",
      "title": $cmp.i18n.listingDetails.supportedLanguagesLabel,
      "badges": $cmp.categoryGroups.languages
    },
    key: 29
  }) : null : null, !$cmp.isConsultantListing ? $cmp.categoryGroups.businessNeeds.length ? api_custom_element("wds-titled-group", _wdsTitledGroup, {
    classMap: stc14,
    attrs: stc19,
    props: {
      "titleTypeStyle": "body-2",
      "titleRole": "heading",
      "titleAriaLevel": "4",
      "title": $cmp.i18n.listingDetails.categoriesGroupV2,
      "badges": $cmp.categoryGroups.businessNeeds
    },
    key: 30
  }) : null : null, !$cmp.isConsultantListing ? $cmp.categoryGroups.industries.length ? api_custom_element("wds-titled-group", _wdsTitledGroup, {
    classMap: stc14,
    attrs: stc20,
    props: {
      "titleTypeStyle": "body-2",
      "titleRole": "heading",
      "titleAriaLevel": "4",
      "title": $cmp.i18n.listingDetails.industriesGroup,
      "badges": $cmp.categoryGroups.industries
    },
    key: 31
  }) : null : null, !$cmp.isConsultantListing ? $cmp.categoryGroups.targetPersonas.length ? api_custom_element("wds-titled-group", _wdsTitledGroup, {
    classMap: stc14,
    attrs: stc21,
    props: {
      "titleTypeStyle": "body-2",
      "titleRole": "heading",
      "titleAriaLevel": "4",
      "title": $cmp.i18n.listingDetails.personasGroup,
      "badges": $cmp.categoryGroups.targetPersonas
    },
    key: 32
  }) : null : null, !$cmp.isConsultantListing ? $cmp.categoryGroups.supportedFeatures.length ? api_custom_element("wds-titled-group", _wdsTitledGroup, {
    classMap: stc14,
    attrs: stc22,
    props: {
      "titleTypeStyle": "body-2",
      "titleRole": "heading",
      "titleAriaLevel": "4",
      "title": $cmp.i18n.listingDetails.featuresGroup,
      "badges": $cmp.categoryGroups.supportedFeatures,
      "tooltip": $cmp.categoryGroups.supportedFeaturesTooltip,
      "tooltipOrientation": $cmp.infoIconTooltipOrientation,
      "flipIfOverflowsViewport": true
    },
    key: 33
  }) : null : null])])]) : null, $cmp.hasCompatibility ? api_custom_element("wds-grid-item", _wdsGridItem, stc23, [api_element("section", {
    classMap: stc24,
    attrs: {
      "data-testid": "compatibility-section",
      "aria-labelledby": api_scoped_id("compatibility-heading")
    },
    key: 35
  }, [api_static_fragment($fragment5, 37, [api_static_part(0, {
    attrs: {
      "id": api_scoped_id("compatibility-heading")
    }
  }, null), api_static_part(1, null, api_dynamic_text($cmp.i18n.compatibility.title))]), api_element("div", stc25, [$cmp.compatibilityBadges.requiredProducts.length ? api_custom_element("wds-titled-group", _wdsTitledGroup, {
    classMap: stc14,
    attrs: stc26,
    props: {
      "title": $cmp.requiredProductsLabel,
      "titleTypeStyle": "body-2",
      "titleRole": "heading",
      "titleAriaLevel": "4",
      "tooltip": $cmp.i18n.listingDetails.tooltipsText.requireContentsTooltip,
      "tooltipOrientation": $cmp.infoIconTooltipOrientation,
      "tooltipAriaLabel": $cmp.requiredProductsTooltipAriaLabel,
      "badges": $cmp.compatibilityBadges.requiredProducts
    },
    key: 39
  }) : null, $cmp.compatibilityBadges.compatibleWith.length ? api_custom_element("wds-titled-group", _wdsTitledGroup, {
    classMap: stc14,
    attrs: stc27,
    props: {
      "title": $cmp.compatibleWithLabel,
      "titleTypeStyle": "body-2",
      "titleRole": "heading",
      "titleAriaLevel": "4",
      "tooltip": $cmp.i18n.listingDetails.tooltipsText.compatibilityToolip,
      "tooltipOrientation": $cmp.infoIconTooltipOrientation,
      "tooltipAriaLabel": $cmp.compatibleWithTooltipAriaLabel,
      "badges": $cmp.compatibilityBadges.compatibleWith
    },
    key: 40
  }) : null, $cmp.compatibilityBadges.salesforceEditions.length ? api_custom_element("wds-titled-group", _wdsTitledGroup, {
    classMap: stc14,
    attrs: stc28,
    props: {
      "title": $cmp.i18n.compatibility.salesforceEditionsGroup,
      "titleTypeStyle": "body-2",
      "titleRole": "heading",
      "titleAriaLevel": "4",
      "badges": $cmp.compatibilityBadges.salesforceEditions
    },
    key: 41
  }) : null, $cmp.compatibilityBadges.supportedLanguages.length ? api_custom_element("wds-titled-group", _wdsTitledGroup, {
    classMap: stc14,
    attrs: stc29,
    props: {
      "title": $cmp.i18n.listingDetails.supportedLanguagesLabel,
      "titleTypeStyle": "body-2",
      "titleRole": "heading",
      "titleAriaLevel": "4",
      "badges": $cmp.compatibilityBadges.supportedLanguages
    },
    key: 42
  }) : null, $cmp.accessibleSolutionURL ? api_custom_element("wds-labeled-value", _wdsLabeledValue, {
    attrs: stc30,
    props: {
      "title": $cmp.i18n.compatibility.accessibility
    },
    key: 43
  }, [api_custom_element("wds-link", _wdsLink, {
    props: {
      "name": "compatibility accessibility report",
      "href": $cmp.accessibleSolutionURL
    },
    key: 44
  }, [api_element("a", {
    classMap: stc31,
    attrs: {
      "href": api_scoped_frag_id($cmp.accessibleSolutionURL),
      "rel": "noopener noreferrer",
      "target": "_blank",
      "aria-label": $cmp.accessibilityLinkAriaLabel,
      "data-testid": "compatibility-accessibility-link"
    },
    key: 45
  }, [api_custom_element("ax-icon", _axIcon, stc32), api_static_fragment($fragment6, 48, [api_static_part(1, null, api_dynamic_text($cmp.i18n.compatibility.accessibilityReportLink))])])])]) : null])])]) : null])])];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-5ej93sof147";
tmpl.legacyStylesheetToken = "undefined-_overviewV2";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
